module.exports = __webpack_public_path__ + "img/menu4.52118ff8.svg";